const STORAGE_KEY = 'hraAnswerPreviewLanguage';

export function getStoredHraPreviewLanguage(fallback = 'en') {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || fallback;
    } catch {
        return fallback;
    }
}

export function setStoredHraPreviewLanguage(language) {
    try {
        if (language) {
            window.localStorage.setItem(STORAGE_KEY, language);
        }
    } catch {
        // ignore quota / private mode
    }
}

export function resolveHraPreviewLanguage(
    availableLanguages = ['en'],
    fallback = 'en'
) {
    const stored = getStoredHraPreviewLanguage(fallback);
    if (availableLanguages.includes(stored)) {
        return stored;
    }
    if (availableLanguages.includes(fallback)) {
        return fallback;
    }
    return availableLanguages[0] || 'en';
}

/** Limit preview language options to company-enabled languages when configured. */
export function filterPreviewLanguages(
    contentLanguages = [],
    enabledLanguages = [],
    fallback = 'en'
) {
    const languages = contentLanguages?.length ? contentLanguages : [fallback];
    if (!enabledLanguages?.length) {
        return languages;
    }
    const filtered = languages.filter((code) =>
        enabledLanguages.includes(code)
    );
    return filtered.length ? filtered : languages;
}

/** Apply preview language to i18n (and optionally persist + reload overrides). */
export async function applyHraPreviewLanguage(
    i18n,
    languageKey,
    { persist = true, refreshOverrides = false } = {}
) {
    if (persist) {
        setStoredHraPreviewLanguage(languageKey);
    }
    await i18n.changeLanguage(languageKey);
    if (refreshOverrides) {
        const { refreshI18nPreview } = await import('./refreshI18nPreview');
        await refreshI18nPreview();
    }
}
